<template>
	<div class=" ">
		<el-card>
			<div slot="header" class="card_title">
				<span>权限管理/新增角色</span>
			</div>
			<div class="add_main hidden_scroll">
				<span class="font_weight_bold">新增(编辑)角色</span>
				<div class="margin_top_20">
					<el-form label-position="right" label-width="120px" :model="formData">
						<el-form-item label="角色名称" class="margin_top_20">
							<el-input v-model="formData.name" placeholder=""></el-input>
						</el-form-item>
						<el-form-item label="角色描述">
							<el-input
								v-model="formData.desc"
								type="textarea"
								:rows="5"
								placeholder=""
							></el-input>
						</el-form-item>

						<el-form-item label="功能权限">
							<el-checkbox-group
								v-model="checkedAuthoritys"
								:min="1"
								:max="100"
							>
								<el-checkbox
									v-for="item in authoritys"
									:label="item.permission"
									:key="item.permission"
									:style="
										item.name.includes('【Tab】') ? { display: 'block' } : {}
									"
								>
									{{ item.name }}
								</el-checkbox>
							</el-checkbox-group>
						</el-form-item>

						<el-form-item>
							<div class="flex justify_content_c align_items_c">
								<el-button
									type="primary"
									class="custom_btn_width_100"
									@click="saveRole"
								>
									保存
								</el-button>
								<el-button class="custom_btn_width_100" @click="back"
									>返回</el-button
								>
							</div>
						</el-form-item>
					</el-form>
				</div>
			</div>
		</el-card>
	</div>
</template>

<script>
import { roleInfo, addRoles, editRoles } from "@/api/limitsauthority";

export default {
	name: "",
	data() {
		return {
			value: "",
			formData: {},
			checkedAuthoritys: [],
			authoritys: [
				{
					name: "主页【Tab】",
					permission: 100,
				},
				{
					name: "用户管理【Tab】",
					permission: 800,
				},
				{
					name: "用户列表",
					permission: 801,
				},
				{
					name: "新增用户",
					permission: 802,
				},
				{
					name: "配置管理",
					permission: 804,
				},
				{
					name: "认证审核",
					permission: 805,
				},
				{
					name: "个人用户新增",
					permission: 806,
				},
				{
					name: "企业用户新增",
					permission: 807,
				},
				{
					name: "普通用户新增",
					permission: 808,
				},
				{
					name: "资讯管理【Tab】",
					permission: 300,
				},
				{
					name: "资讯列表",
					permission: 301,
				},
				{
					name: "新增资讯",
					permission: 302,
				},
				{
					name: "快讯模版",
					permission: 303,
				},
				{
					name: "恢复数据",
					permission: 304,
				},
				{
					name: "类别管理",
					permission: 305,
				},
				{
					name: "专区管理",
					permission: 306,
				},
				{
					name: "专题管理",
					permission: 307,
				},
				{
					name: "工具管理",
					permission: 308,
				},
				{
					name: "新增工具",
					permission: 309,
				},
				{
					name: "新增专题",
					permission: 310,
				},
				{
					name: "审核管理",
					permission: 311,
				},
				{
					name: "活动管理【Tab】",
					permission: 400,
				},
				{
					name: "活动管理",
					permission: 401,
				},
				{
					name: "订单管理",
					permission: 402,
				},
				{
					name: "新增活动",
					permission: 403,
				},
				{
					name: "side活动",
					permission: 404,
				},
				{
					name: "side详情",
					permission: 405,
				},
				{
					name: "otherSide详情",
					permission: 406,
				},
				{
					name: "推荐配置【Tab】",
					permission: 600,
				},
				{
					name: "推荐Banner管理",
					permission: 601,
				},
				{
					name: "Banner详情",
					permission: 602,
				},
				{
					name: "活动置顶管理",
					permission: 603,
				},
				{
					name: "DataEra【Tab】",
					permission: 500,
				},
				{
					name: "BTC持币机构",
					permission: 501,
				},
				{
					name: "消息管理【Tab】",
					permission: 700,
				},
				{
					name: "推送信息",
					permission: 701,
				},
				{
					name: "问题反馈",
					permission: 702,
				},
				{
					name: "举报信息",
					permission: 703,
				},
				{
					name: "新增APP推送信息",
					permission: 704,
				},
				{
					name: "Telegram推送",
					permission: 705,
				},
				{
					name: "新增Bot",
					permission: 706,
				},
				{
					name: "Bot详情",
					permission: 707,
				},
				{
					name: "权限管理【Tab】",
					permission: 900,
				},
				{
					name: "管理人员管理",
					permission: 901,
				},
				{
					name: "新增管理人员",
					permission: 902,
				},
				{
					name: "角色管理",
					permission: 903,
				},
				{
					name: "新增角色",
					permission: 904,
				},
				{
					name: "人员信息详情",
					permission: 905,
				},
				{
					name: "运营数据【Tab】",
					permission: 200,
				},
				{
					name: "全站数据",
					permission: 201,
				},
				{
					name: "文章列表",
					permission: 202,
				},
				{
					name: "单篇数据",
					permission: 203,
				},
				{
					name: "数据概览",
					permission: 204,
				},
				{
					name: "科学实验【Tab】",
					permission: 1000,
				},
				{
					name: "编辑器",
					permission: 1001,
				},
				{
					name: "预测市场【Tab】",
					permission: 1100,
				},
				{
					name: "事件列表",
					permission: 1101,
				},
				{
					name: "下载提示配置【Tab】",
					permission: 1200,
				},
			],
		};
	},

	mounted() {
		if (this.$route.query.id) {
			this.getRoleDetails();
		}
	},

	methods: {
		saveRole() {
			console.log("formData", this.checkedAuthoritys);
			const that = this;
			var params = {
				id: this.$route.query.id,
				name: this.formData.name,
				desc: this.formData.desc,
				state: 1,
				permissions: this.checkedAuthoritys.join(","),
			};
			if (this.$route.query.id) {
				editRoles(params)
					.then((res) => {
						if (res.code == 200) {
							that.$message.success("编辑成功");
							that.$router.push({ path: "/limitsauthority/role" });
						} else {
							that.$message.error(res.message);
						}
					})
					.catch((error) => {
						that.$message.error(error.message);
					});
			} else {
				addRoles(params)
					.then((res) => {
						if (res.code == 200) {
							that.$message.success("创建成功");
							that.$router.push({ path: "/limitsauthority/role" });
						} else {
							that.$message.error(res.message);
						}
					})
					.catch((error) => {
						that.$message.error(error.message);
					});
			}
		},
		getRoleDetails() {
			const that = this;
			roleInfo({ id: this.$route.query.id })
				.then((res) => {
					if (res.code == 200) {
						that.formData = res.data;
						that.checkedAuthoritys = res.data.permissions
							.split(",")
							.map(Number);
					} else {
						that.$message.error(res.message);
					}
				})
				.catch((error) => {
					that.$message.error(error.message);
				});
		},
		back() {
			this.$router.push({ path: "/limitsauthority/role" });

			// this.$confirm("取消编辑将丢失已经修改的数据，确认取消编辑吗？", "提示", {
			// 	confirmButtonText: "确定",
			// 	cancelButtonText: "取消",
			// 	type: "warning",
			// })
			// 	.then(() => {
			// 		this.$router.push({ path: "/limitsauthority/role" });
			// 	})
			// 	.catch(() => {
			// 		this.$message({
			// 			type: "info",
			// 			message: "已取消返回",
			// 		});
			// 	});
		},
	},
};
</script>

<style scoped>
.main {
	width: calc(100% - 40px);
}

.add_main {
	width: 70%;
	height: 81vh;
	overflow-y: scroll;
	margin: 0 auto;
}
</style>
